// extracted by mini-css-extract-plugin
export default {"stepIcon":"ProgressBar_stepIcon__UH-ZY","successCheckIcon":"ProgressBar_successCheckIcon__Z4lIt"};